import { supabase } from '../supabaseClient';

interface IncidentEvidenceRef {
  id: string;
  company_id: string;
  attachment_url: string | null;
  attachment_name: string | null;
}

// El bucket incident-evidence guarda cada evidencia en `{company_id}/{incident_id}.{ext}`.
// attachment_url puede traer la URL pública completa de una fila anterior a la migración
// a bucket privado (contiene 'incident-evidence/') o, en filas nuevas, el path directo.
export function getIncidentEvidencePath(incident: IncidentEvidenceRef): string | null {
  if (!incident.attachment_url) return null;
  if (incident.attachment_url.startsWith('http')) {
    const marker = '/incident-evidence/';
    const idx = incident.attachment_url.indexOf(marker);
    return idx === -1 ? null : incident.attachment_url.slice(idx + marker.length);
  }
  return incident.attachment_url;
}

export async function openIncidentEvidence(incident: IncidentEvidenceRef): Promise<void> {
  const path = getIncidentEvidencePath(incident);
  if (!path) return;

  const { data, error } = await supabase.storage.from('incident-evidence').createSignedUrl(path, 60);
  if (error || !data) {
    alert('Error al generar el enlace de descarga: ' + (error?.message ?? 'error desconocido'));
    return;
  }
  window.open(data.signedUrl, '_blank', 'noopener,noreferrer');
}
